import { render, staticRenderFns } from "./MyShippingDetails.vue?vue&type=template&id=a1661d3c&scoped=true&"
import script from "./MyShippingDetails.vue?vue&type=script&lang=js&"
export * from "./MyShippingDetails.vue?vue&type=script&lang=js&"
import style0 from "./MyShippingDetails.vue?vue&type=style&index=0&id=a1661d3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1661d3c",
  null
  
)

export default component.exports